import type { AppModule } from '@ohmybible/core';

import * as routes from './routes.js';

export const UsersModule: AppModule = {
  routes,
};
